import React, { useState, Fragment } from "react";
import HTMLParser from "../../htmlParser";
import Parser from "../../parser";
require("../../../styles/tabs.scss");
const LockedGroupTabs = (props) => {
    const [tabShown, showTab] = useState(0);
    let className = "tabs ";
    className += props.attributes.className || "";
    return (React.createElement("div", { id: props.anchor || props.attributes.anchor, className: className, style: props.style }, props.innerBlocks.map((tab, tabId) => {
        return (React.createElement(Fragment, { key: tabId }, tab.innerBlocks.map((element, i) => {
            if (i === 0) {
                const level = element.attributes.level || 2;
                const TagName = "h" + level;
                let className = "tab-title";
                className += element.attributes.className
                    ? " " + element.attributes.className
                    : "";
                className += tab.attributes.backgroundColor
                    ? " has-" +
                        tab.attributes.backgroundColor +
                        "-background-color"
                    : "";
                if (element.attributes.textAlign) {
                    className +=
                        " has-text-align-" + element.attributes.textAlign;
                }
                return (React.createElement(TagName, { id: element.anchor, "data-shown": tabShown === tabId, style: { "--id": tabId }, key: i, className: className },
                    React.createElement("button", { onClick: () => {
                            showTab(tabId);
                        } },
                        React.createElement(HTMLParser, null, element.attributes.content))));
            }
            return (React.createElement("div", { "data-shown": tabShown === tabId, className: "tab-content" +
                    (tab.attributes.backgroundColor
                        ? " has-" +
                            tab.attributes.backgroundColor +
                            "-background-color"
                        : ""), key: i },
                React.createElement(Parser, { structure: element.innerBlocks })));
        })));
    })));
};
export default LockedGroupTabs;
